<template>
  <div class="logis" :class="addFooter?'logis-he':''">
    <el-container style="height:100%" class="oio">
      <el-aside width="200px" height="100%" :style="aff?'min-height: 850px;':''">
        <div class="LogisticsManage-left">
          <el-menu default-active="2" class="el-menu-vertical-demo" router>
            <div class="LogisticsManage-wlgj">物流管家</div>
            <el-menu-item
              @click="clickQwe"
              style="padding-left: 0px;"
              index="/logisticsManage/order"
              :style="highlight2?'color: #1B1464;font-size: 18px;font-family: SourceHanSans-Medium ':'color: #1B1464; font-family: SourceHanSans-Regular'"
              :class="highlight2? 'highlighty2':''"
            >
              <i
                class="icons_lo_order"
                :style="numName === '订单管理'?'color: #1B1464;':'color: #1B1464;'"
              ></i>
              <span slot="title">订单管理</span>
            </el-menu-item>
            <el-menu-item
              style="padding-left: 0px;"
              index="/logisticsManage/bill"
              :style="highlight3?'color: #1B1464;font-size: 18px;font-family: SourceHanSans-Medium':'color: #1B1464;font-family: SourceHanSans-Regular'"
              :class="highlight3? 'highlighty2':''"
            >
              <i
                class="icons_lo_bill"
                :style="numName === '结算管理'?'color: #1B1464;':'color: #1B1464;'"
              ></i>
              <span slot="title">结算管理</span>
            </el-menu-item>
            <el-menu-item
              @click="clickQwa"
              style="padding-left: 0px;"
              index="/logisticsManage/account"
              :style="highlight?'color: #1B1464;font-size: 18px;font-family: SourceHanSans-Medium':'color: #1B1464;font-family: SourceHanSans-Regular'"
              :class="highlight? 'highlightx':''"
            >
              <i
                class="icons_lo_us"
                :style="numName === '账户管理'?'color: #1B1464;':'color: #1B1464;'"
              ></i>
              <span slot="title">账户管理</span>
            </el-menu-item>
          </el-menu>
        </div>
      </el-aside>

      <el-container>
        <div style="width: 100% ">
          <div class="boox">
            <el-main class="tit_box">
              <div class="LogisticsManage-right">
                <div class="mbx-account">
                  <span>{{numName}}</span>
                  <span class="shu">丨</span>
                </div>

                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item :to="{ path: '/home' }">
                    <div class="log-price-tag"></div>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item :to="{ path: '/logisticsManage/account' }">
                    <span
                      class="ac_wlgj"
                      @click="clickQwa"
                      style="font-style: norma;line-height: normal;"
                    >物流管家</span>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item class="lo_xz" v-if="this.numName === '账户管理'">{{numName}}</el-breadcrumb-item>
                  <el-breadcrumb-item class="lo_xz" v-if="this.numName === '订单管理'">{{numName}}</el-breadcrumb-item>
                  <el-breadcrumb-item class="lo_xz" v-if="this.numName === '结算管理'">{{numName}}</el-breadcrumb-item>
                  <!-- <el-breadcrumb-item v-if="numName === '账户管理'">基本信息</el-breadcrumb-item> -->
                </el-breadcrumb>
              </div>
              <router-view />
            </el-main>
          </div>
        </div>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      numName: "账户管理"
    };
  },

  methods: {
    clickQwe() {
      this.numName = "订单管理";
    },
    clickQwa() {
      this.numName = "账户管理";
    },
    clickQwc() {
      this.numName = "结算管理";
    }
  },
  computed: {
    addFooter: {
      //用于控制底部样式new-nav-footer加载
      get: function() {
        if (this.$route.name) {
          switch (this.$route.name) {
            case "Account":
              return true;
              break;
          }
        }
      }
    },
    highlight: {
      get: function() {
        if (this.$route.name) {
          switch (this.$route.name) {
            case "Account":
              this.clickQwa();
              return true;
              break;
          }
        }
      }
    },
    highlight2: {
      get: function() {
        if (this.$route.name) {
          switch (this.$route.name) {
            case "Order":
              this.clickQwe();
              return true;
            case "OrderTwo":
              this.clickQwe();
              return true;
              break;
          }
        }
      }
    },

    highlight3: {
      get: function() {
        if (this.$route.name) {
          switch (this.$route.name) {
            case "Bill":
              this.clickQwc();
              return true;
              break;
          }
        }
      }
    },
    aff: {
      get: function() {
        if (this.$route.name) {
          switch (this.$route.name) {
            case "Bill":
              return true;
              break;
            case "Order":
              return true;
              break;
            default:
              return false;
              break;
          }
        }
      }
    }
  }
};
</script>

<style>
html,
body {
  width: 100% !important;
}
</style>

<style scoped>
.boox {
  width: 1000px;
}
.gun {
  position: inherit;
  width: 100%;
}

.logis {
  position: relative;
}
.tit_box {
  padding: inherit !important;
  padding-left: 20px !important;
  padding-top: 20px !important;
  overflow: visible;
}
.oio {
  width: 1200px;
  margin: 0 auto;
}
.LogisticsManage-left {
  height: 100%;
  background-color: #fff;
  border-right: solid 1px #e6e6e6;
  border-left: solid 1px #e6e6e6;
}
.LogisticsManage-left .el-menu {
  border-right: none;
}

.LogisticsManage-wlgj {
  height: 65px;
  line-height: 64px;
  margin-left: -45px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #999999;
  letter-spacing: 0;
}

.mbx-account {
  position: absolute;
  font-size: 18px;
  font-weight: 600;
}

.LogisticsManage-right {
  position: relative;
  padding-bottom: 25px;
}
.el-breadcrumb {
  padding-left: 100px;
  padding-top: 5px;
}
.shu {
  color: #ccc;
}
.modole {
  margin-top: 20px;
}
.logis-he {
  height: 100%;
}
.highlighty2 {
  padding-left: 12px !important;
  background: #eeecff !important;
}
.highlightx:hover {
  background: #eeecff !important;
}
.highlightx {
  padding-left: 12px !important;
  background-color: #eeecff !important;
}
.icons_lo_us {
  display: inline-block;
  width: 16px;
  height: 15px;
  background: url("../assets/img/icon-management.png") center center;
  position: relative;
  top: 0px;
  left: -5px;
}
.icons_lo_bill {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url("../assets/img/icon-bill.png") center center;
  position: relative;
  top: 0px;
  left: -5px;
}
.icons_lo_order {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url("../assets/img/icon-order.png") center center;
  position: relative;
  top: 0px;
  left: -5px;
}
</style>



// WEBPACK FOOTER //
// src/views/LogisticsManage.vue